import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import {
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
  TextField,
  IconButton,
  colors,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import ButtonLoading from 'components/ButtonLoading';

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    fontSize: '16px',
    paddingTop: 8,
    fontWeight: 700,
    color: theme.palette.black,
  },
  modalTitleDialog: {
    borderBottom: `1px solid ${colors.grey[200]}`,
  },
  dialogActions: {
    borderTop: '1px solid',
    borderColor: colors.grey[200],
    padding: '16px 24px',
    marginTop: 15,
  },
  dialogText: {
    maxWidth: 410,
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '18px',
    marginTop: '20px',
    letterSpacing: 0.3,
    color: '#263238',
  },
  cancelButton: {
    color: theme.palette.white,
    backgroundColor: colors.red[600],
    '&:hover': {
      backgroundColor: colors.red[900],
    },
  },
  textField: {
    marginTop: theme.spacing(2),
    width: '100%',
  },
}));

const AcceptModal = ({
  reasons,
  opened,
  loading,
  onCloseModal,
  onSetReason,
  acceptButtonText,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [AcceptReason, setAcceptReason] = React.useState('');
  const [comment, setComment] = React.useState('');
  const handleChange = (r) => {
    setAcceptReason(r);
  };
  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };
  return (
    <>
      {opened ? (
        <Dialog
          style={{ width: '100%', maxWidth: 524, margin: 'auto' }}
          open={opened}
          onClose={() => onCloseModal(false)}>
          <DialogTitle className={classes.modalTitleDialog}>
            <div className={classes.modalTitle}>
              <Typography variant="h4">{t('accept_session')}</Typography>
              <IconButton
                style={{ position: 'absolute', right: '8px', top: '1px' }}
                onClick={() => onCloseModal(false)}>
                <CloseIcon />
              </IconButton>
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Typography variant="subtitle2" className={classes.dialogText}>
                {t('are_about_to_accept')}
              </Typography>
              <Typography variant="subtitle2" className={classes.dialogText}>
                {t('are_about_to_accept_description')}
              </Typography>
              <Typography
                variant="subtitle2"
                style={{ marginTop: 0 }}
                className={classes.dialogText}>
                {t('no_exceptions')}
              </Typography>
            </DialogContentText>
          </DialogContent>

          <DialogContent>
            <FormControl variant="outlined">
              <InputLabel id="demo-simple-select-outlined-label">
                {t('exception')}
              </InputLabel>
              <Select
                style={{ minWidth: '410px' }}
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={AcceptReason.message}
                label="Choose a reason"
                disabled={loading}>
                <MenuItem
                  value="No reason"
                  key=""
                  onClick={() =>
                    handleChange({
                      message: '',
                      accept_reason_code: null,
                    })
                  }>
                  No Exceptions
                </MenuItem>
                {reasons.map((reason) => (
                  <MenuItem
                    onClick={() => handleChange(reason)}
                    value={reason.accept_reason_code}
                    key={reason.accept_reason_code}>
                    {reason.message}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              disabled={loading}
              className={classes.textField}
              variant="outlined"
              label="Comment (optional)"
              value={comment}
              onChange={handleCommentChange}
              multiline
              rows={4}
            />
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button
              color="primary"
              variant="outlined"
              onClick={() => onCloseModal(false)}>
              {t('Cancel')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => onSetReason({ ...AcceptReason, comment })}
              disabled={!AcceptReason || loading}>
              {loading ? (
                <ButtonLoading />
              ) : (
                <>{acceptButtonText ? t(acceptButtonText) : t('Accept Now')}</>
              )}
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
    </>
  );
};

export default AcceptModal;
